<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    v-model="menu"
    @close="handleDatesFilterChange"
  >
    <template v-slot:activator="{ on }">
      <v-btn :class="classes" v-on="on" v-bind="$attrs">
        <template v-slot:default>
          <div v-if="dateMin && !dateMax">
            {{
              $t('message.boilerplate.filters.from', {
                date: formatDateToInputDate(new Date(dateMin)),
              })
            }}
          </div>
          <div v-else-if="dateMax && !dateMin">
            {{
              $t('message.boilerplate.filters.til', {
                date: formatDateToInputDate(new Date(dateMax)),
              })
            }}
          </div>
          <div v-else-if="dateMax && dateMin">
            {{
              $t('message.boilerplate.filters.fromTo', {
                dateMin: formatDateToInputDate(new Date(dateMin)),
                dateMax: formatDateToInputDate(new Date(dateMax)),
              })
            }}
          </div>
          <div v-else>
            {{ noFilterLabel }}
          </div>
        </template>
      </v-btn>
    </template>
    <div class="pa-3 background">
      <v-text-field
        :label="generateMessage('boilerplate.filters.dateMin')"
        v-model="newDateMin"
        clearable
        :type="type"
        outlined
        :max="newDateMax"
      ></v-text-field>
      <v-text-field
        :label="generateMessage('boilerplate.filters.dateMax')"
        v-model="newDateMax"
        :type="type"
        clearable
        outlined
        :min="newDateMin"
      ></v-text-field>
      <v-btn @click="handleDatesFilterChange">
        {{ generateMessage('boilerplate.filters.validate') }}
      </v-btn>
    </div>
  </v-menu>
</template>
<script>
import { formatDateToInputDate } from '@/business/utils/dates';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'FilterByDate',
  inheritAttrs: false,
  props: {
    namespace: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    classes: {
      type: String,
      required: false,
    },
    attribute: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    noFilterLabel() {
      return this.label || this.generateMessage('boilerplate.filters.date');
    },
    dateMin: {
      get() {
        return this.attribute
          ? this.$store.getters[`${this.namespace}/attributesObj`][
              this.attribute
            ].values[0]
          : this.$store.getters[`${this.namespace}/dateMin`];
      },
    },
    dateMax: {
      get() {
        return this.attribute
          ? this.$store.getters[`${this.namespace}/attributesObj`][
              this.attribute
            ].values[1]
          : this.$store.getters[`${this.namespace}/dateMax`];
      },
    },
  },
  data() {
    return {
      menu: false,
      newDateMin: null,
      newDateMax: null,
    };
  },
  watch: {
    menu(val) {
      if (!val) {
        this.handleDatesFilterChange();
      } else {
        this.$emit('click');
      }
    },
  },
  mounted() {
    this.newDateMin = this.dateMin;
    this.newDateMax = this.dateMax;
  },
  methods: {
    formatDateToInputDate,
    generateMessage,
    handleDatesFilterChange() {
      this.menu = false;
      if (
        this.newDateMin !== this.dateMin ||
        this.newDateMax !== this.dateMax
      ) {
        this.$store.dispatch(`${this.namespace}/setDatesFilter`, {
          dateMin: this.newDateMin,
          dateMax: this.newDateMax,
          attribute: this.attribute,
        });
      }
    },
  },
};
</script>
